<!--导入修改费用-->
<template>
  <div class="flex-c">
    <el-button
      icon="el-icon-download"
      size="small"
      type="primary"
      style="margin: 0 10px 10px 0"
      @click="operationBtn"
    >
      {{ $t('basicData.DownloadTheTemplate') }}
    </el-button>
    <upload-excel
      :on-success="importLogistics"
      :but-name="$t('receivablePayable.ImportModifyExpenses')"
    />
  </div>
</template>

<script>
import uploadExcel from '@/components/UploadExcel';
import {
  apiPayableSiteExpenseImportEditFee,
  apiPayableSiteExpenseTemplate
} from '@/api/finance/receivables';
import { goFileUploadManagement } from '@/utils/goExportList.js';
import { saveAs } from 'file-saver';

import i18n from '@/lang';

const MAX_LENGTH = 100000;
const str1 = i18n.t('receivablePayable.ThirdPartyCollection'); // 第三方收款
const str2 = i18n.t('receivablePayable.AnjunCottage'); // 安俊
const str3 = i18n.t('receivablePayable.AJDDispatch'); // AJD
const str4 = i18n.t('receivablePayable.DSPDispatch'); // DSP
const str5 = i18n.t('receivablePayable.postOfficeDelivery'); // 邮局派送

export default {
  name: 'ImportEditFees',

  components: {
    uploadExcel
  },

  props: {
    calculationType: {
      type: Number,
      default: 2
    },
    // 账单类型
    payableType: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      feeType: null
    };
  },

  created() {
    // 每次最多导入xxxx条数据
    this.lenTips = this.$t('receivablePayable.Only100000PiecesImport');
  },
  methods: {
    // 导入文件为填项补充
    dataSorting(header, result) {
      const arrData = result.map(item => {
        header.map(list => {
          item[list] = item[list];
          for (const k in item) {
            if (list === k) {
              item[list] = (item[list] !== null && item[list] !== undefined && item[list] !== '') ? item[list] : '';
            }
          }
        });
        return item;
      });
      return arrData;
    },
    // 将文件头按组分类
    groupHeader(arr, length) {
      let ind = 0;
      const newArr = [];
      while (ind < arr.length) {
        newArr.push(arr.slice(ind, ind += length));
      }
      return newArr;
    },

    /**
     * 导入修改费用数据
     * @param arr {Array} 文件头数据
     */
    importLogistics(arr) {
      const feeType1 = arr[1].results[0];
      this.feeType = {};
      for (const k1 in feeType1) {
        this.feeType[feeType1[k1]] = k1;
      }
      const headerDataArr = [];
      arr[0].header.map(item => {
        if (item.indexOf('UNKNOWN') === -1) {
          headerDataArr.push(item);
        }
      });
      const logisticsNo = {};
      logisticsNo[headerDataArr[0]] = 'waybillNumber';
      logisticsNo[headerDataArr[1]] = 'businessType';
      logisticsNo[headerDataArr[2]] = 'chargeWeight';
      const headerArr = headerDataArr.slice(3);
      const header = this.groupHeader(headerArr, 2);
      const headObj = header.map(item => {
        const obj = {};
        item.map((list, ind) => {
          switch (ind) {
            case 0:
              obj[list] = 'fee';
              break;
            case 1:
              obj[list] = 'remark';
              break;
          }
        });
        return obj;
      });
      const results = arr[0].results.slice(2);
      const allData = this.dataSorting(headerDataArr, results);
      const dataArr = [];
      allData.map((item) => {
        const dataObj = {};
        const priceItemList = [];
        headObj.map(list => {
          const dataKey = {};
          let chargeWeight = '';
          let businessType = '';
          for (const k in item) {
            if (k === headerDataArr[0]) {
              dataObj[logisticsNo[k]] = item[k];
              dataObj['priceItemList'] = [];
            }
            if (k === headerDataArr[1]) {
              if (item[k]) {
                businessType = item[k].split('-')[1] || '';
                dataObj[logisticsNo[k]] = businessType;
              }
            }
            if (k === headerDataArr[2]) {
              chargeWeight = item[k] ? item[k] : '';
              dataObj[logisticsNo[k]] = chargeWeight;
            }
            dataKey[list[k]] = list[k] ? item[k] : '';
            if (list[k] === 'fee') {
              dataKey['feeCode'] = feeType1[k];
            }
          }

          {
            const { fee, feeCode, remark } = dataKey;
            const isFee = fee !== null && fee !== undefined && fee !== '';
            const isFeeCode = feeCode !== null && feeCode !== undefined && feeCode !== '';
            const isRemark = remark !== null && remark !== undefined && remark !== '';
            if (isFee || isRemark) {
              const obj = {
                fee: isFee ? fee.toString().trim() : '',
                feeCode: isFeeCode ? feeCode.toString().trim() : '',
                remark: isRemark ? remark.toString().trim() : ''
              };
              priceItemList.push(obj);
            }
          }
          // if (dataKey.fee || dataKey.remark) {
          //   const obj = {
          //     fee: (dataKey.fee !== null && dataKey.fee !== undefined && dataKey.fee !== '') ? dataKey.fee.toString().trim() : '',
          //     feeCode: (dataKey.feeCode !== null && dataKey.feeCode !== undefined && dataKey.feeCode !== '') ? dataKey.feeCode.toString().trim() : '',
          //     remark: (dataKey.remark !== null && dataKey.remark !== undefined && dataKey.remark !== '') ? dataKey.remark.toString().trim() : ''
          //   };
          //   priceItemList.push(obj);
          // }
        });
        dataObj['priceItemList'] = priceItemList;
        dataArr.push(dataObj);
      });

      // 数据数量校验
      if (dataArr.length === 0) {
        this.$message({
          type: 'warning',
          message: this.$t('userManage.ImportDataIsEmpty')
        });
        return;
      }
      if (dataArr.length > MAX_LENGTH) {
        this.$message({
          type: 'warning',
          message: this.$t('receivablePayable.Only100000PiecesImport')
        });
        return;
      }
      apiPayableSiteExpenseImportEditFee({
        list: dataArr,
        payableType: this.payableType
      }).then(res => {
        if (res.code === 200) {
          this.$message.success(this.$t('basicData.TheOperationSucceeded'));
          goFileUploadManagement(this);
          this.$emit('changeFeeList', true);
        }
      });
    },

    // 下载模板
    operationBtn() {
      const saveName = (() => {
        switch (this.payableType) {
          case 1:
            return str2;
          case 2:
            return str1;
          case 3:
            return str3;
          case 6:
            return str5;
          default:
            return str4;
        }
      })() + this.$t('receivablePayable.ImportModifyExpenses') + '.xlsx';
      apiPayableSiteExpenseTemplate(this.payableType).then(res => {
        saveAs(res.data, `${saveName}`);
      });
    }
  }
};
</script>

<style scoped>
.flex-c {
  display: flex;
  flex-wrap: wrap;
}
</style>
